(function () {
  function toggleComplementary(available) {
    const section = document.querySelector(
      'complementary-products, .complementary-products, [id*="complementary"]'
    );
    if (!section) return;
    section.style.display = available ? '' : 'none';
  }

  // Ascolta il cambio variante nativo di Dawn
  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant) {
      toggleComplementary(false);
      return;
    }
    toggleComplementary(e.detail.variant.available);
  });

  // Stato iniziale al caricamento pagina
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;

    // Leggi disponibilità dalla variante iniziale via Liquid (vedi Step 2)
    const available = window.__initialVariantAvailable;
    if (typeof available !== 'undefined') {
      toggleComplementary(available);
    }
  });
})();
